export default __webpack_public_path__ + "static/media/DinithiPeiris.0b0d9fbf.jpg";